<template>
  <header class="header-global">
    <base-nav class="navbar-main" type="" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img
          src="img/logo.png"
          alt="image du logo de panneau mobile vélo publicitaire au bénin. Benin street marketing regie publicitaire"
          class="logo"
        />
        <span class="ml-2">Panneau Mobile</span>
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="">
            <img
              src="img/logo.png"
              alt="image du logo de panneau mobile vélo publicitaire au bénin. Benin street marketing regie publicitaire"
            />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul
        class="navbar-nav navbar-nav-hover align-items-lg-center text-white ml-lg-auto"
      >
        <li class="nav-link" @click="goto('/')">
          <!-- <i class="fa fa-home"></i> -->
          <span class="">Accueil</span>
        </li>
        <li class="nav-link" @click="goto('produits')">
          <span class="">Produits</span>
        </li>
        <li class="nav-link" @click="goto('realisations')">
          <span class="">Réalisations</span>
        </li>
        <li class="nav-link" @click="goto('equipe')">
          <span class="">&Eacute;quipe</span>
        </li>
        <li class="nav-link" @click="goto('contact')">
          <span class="">Contact</span>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  methods: {
    goto(index) {
      this.$router.push(index);
    },
  },
};
</script>
<style>
.logo {
  height: 40px;
}
</style>
